<template>
  <div :class="[showHistory ? 'col-auto' : 'min-width', 'tabs']">
    <q-tabs
      dense
      no-caps
      v-model="tab"
      class="tab-info"
      indicator-color="transparent"
    >
      <q-tab name="current">
        Atendimento
      </q-tab>
      <q-separator vertical />
      <q-tab
        name="history"
        v-if="showHistory"
      >
        Histórico
      </q-tab>
    </q-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      tab: 'current'
    }
  },

  computed: {
    ...mapState({
      showHistory: ({ agentModule }) => isTruthy(agentModule?.provision?.attendanceHistory)
    })
  },

  watch: {
    tab (tab) {
      this.$emit('change-view', tab)
    }
  }
}

const isTruthy = (val) => ['1', 't', 'true', 'yes', 'y'].includes(String(val).toLowerCase().trim())
</script>

<style lang="sass" >

.tabs
  max-width: 585px !important

.min-width
  min-width: 35%

.tab-info
  color: #263238
  font-size: 13px
  line-height: 14px
  font-weight: 400

  .q-tab--active
    color: #01579b
    font-weight: 500
    background-color: #f6f8fa
</style>
